import React from "react";
import { Route, Navigate, RouteProps } from "react-router-dom";

// components
import PrivateRoute from "./PrivateRoute";

// auth2
const Login2 = React.lazy(() => import("../pages/auth2/Login2"));
const Logout2 = React.lazy(() => import("../pages/auth2/Logout2"));
const Login = React.lazy(() => import("../pages/auth2/LoginNew"));
const Register2 = React.lazy(() => import("../pages/auth2/Register2"));
const Confirm2 = React.lazy(() => import("../pages/auth2/Confirm2"));
const ForgetPassword2 = React.lazy(() => import("../pages/auth2/ForgetPassword2"));
const LockScreen2 = React.lazy(() => import("../pages/auth2/LockScreen2"));
const SignInSignUp2 = React.lazy(() => import("../pages/auth2/SignInSignUp2"));

// dashboard
const Dashboard4 = React.lazy(() => import("../pages/dashboard/Dashboard4/"));
const AdminDashboard = React.lazy(() => import("../pages/AdminDashboard/index"));

//Revenue
const Revenue = React.lazy(() => import("../pages/master/Revenue/Revenue"));
const RevenueOld = React.lazy(() => import("../pages/master/Revenue Old/RevenueOld"));

// master data
const Category = React.lazy(() => import("../pages/master/Category"));
const Currency = React.lazy(() => import("../pages/master/Currency"));
const Manage = React.lazy(() => import("../pages/master/Coupons/Manage"));
const Users = React.lazy(() => import("../pages/master/Users"));
const Orders = React.lazy(() => import("../pages/master/Orders"));
const Course = React.lazy(() => import("../pages/master/Course"));
const SubCourse = React.lazy(() => import("../pages/master/SubCourse"));
const Video = React.lazy(() => import("../pages/master/Video"));

const News = React.lazy(() => import("../pages/master/News"));
const WhoAreWe = React.lazy(() => import("../pages/master/WhoAreWe"));
const TermsAndConditions = React.lazy(() => import("../pages/master/TermsnConditions"));
const MainBanner = React.lazy(() => import("../pages/master/MainBanner"));
const Faq = React.lazy(() => import("../pages/master/Faq"));
const Testimonial = React.lazy(() => import("../pages/master/Testimonial"));
const CongratulationBox = React.lazy(() => import("../pages/master/CongratulationBox"));
const Footer = React.lazy(() => import("../pages/master/Footer"));
const Banner = React.lazy(() => import("../pages/master/Banner"));
const NewsBanner = React.lazy(() => import("../pages/master/NewsBanner"));
const Enquiry = React.lazy(() => import("../pages/master/Enquiry"));
const Subscription = React.lazy(() => import("../pages/master/Subscriptions"));
const InfluencerReport = React.lazy(() => import("../pages/master/Coupons/Report"));
const CouponReport = React.lazy(() => import("../pages/master/Coupons/CouponReport"));
const ManageInfluencerPersons = React.lazy(() => import("../pages/master/Influencers/ManageInfluencerPersons"));
const InfluencerCoupons = React.lazy(() => import("../pages/master/Influencers/InfluencerCoupons"));
const InfluencerCouponReports = React.lazy(() => import("../pages/master/Influencers/InfluencerCouponReports"));
const InfluencerCommisionReports = React.lazy(() => import("../pages/master/Influencers/InfluencerCommisonReports"));
const InfluencerPayouts = React.lazy(() => import("../pages/master/Influencers/Payouts"));
const PayoutDetails = React.lazy(() => import("../pages/master/Coupons/PayoutDetails"));
const PayoutByInfluencer = React.lazy(() => import("../pages/master/PayoutByInfluencer"));

export interface RoutesProps {
  path: RouteProps["path"];
  name?: string;
  element?: RouteProps["element"];
  route?: any;
  exact?: boolean;
  icon?: string;
  header?: string;
  roles?: string[];
  children?: RoutesProps[];
}

const dashboardRoutes: RoutesProps = {
  path: "/dash",
  name: "Dashboards",
  icon: "airplay",
  roles: ["admin"],
  header: "Navigation",
  children: [
    {
      path: "/",
      name: "Root",
      element: <Navigate to="/dashboard" />,
      route: PrivateRoute,
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      element: <PrivateRoute roles={["admin", "influencer"]} component={Dashboard4} />,
      route: PrivateRoute,
    },
  ],
};

const masterDataRoutes: RoutesProps = {
  path: "/master",
  name: "Master",
  icon: "airplay",
  roles: ["admin"],
  header: "Navigation",
  children: [
    {
      path: "/revenue",
      name: "Revenue",
      element: <PrivateRoute roles={["admin"]} component={Revenue} />,
      route: PrivateRoute,
    },
    // {
    //   path: "/revenue_usd",
    //   name: "Revenue(USD)",
    //   element: <PrivateRoute roles={["admin"]} component={RevenueOld} />,
    //   route: PrivateRoute,
    // },
    {
      path: "/currency",
      name: "Currency",
      element: <PrivateRoute roles={["admin"]} component={Currency} />,
      route: PrivateRoute,
    },
    // {
    //   path: "/coupons/manage",
    //   name: "Mangae",
    //   element: <PrivateRoute roles={["admin"]} component={Manage} />,
    //   route: PrivateRoute,
    // },
    {
      path: "/influencers/commisions_report",
      name: "influencer commmison report",
      element: <PrivateRoute roles={["admin"]} component={InfluencerReport} />,
      route: PrivateRoute,
    },
    {
      path: "/influencers/coupon_report",
      name: "influencer coupon report",
      element: <PrivateRoute roles={["admin"]} component={CouponReport} />,
      route: PrivateRoute,
    },
    {
      path: "/influencers/manage",
      name: "influencer manage",
      element: <PrivateRoute roles={["admin"]} component={ManageInfluencerPersons} />,
      route: PrivateRoute,
    },
    {
      path: "/influencers/payouts",
      name: "influencer payouts",
      element: <PrivateRoute roles={["admin"]} component={PayoutDetails} />,
      route: PrivateRoute,
    },
    {
      path: "/payouts-influencer/:id",
      name: "payouts influencer",
      element: <PrivateRoute roles={["admin"]} component={PayoutByInfluencer} />,
      route: PrivateRoute,
    },
    {
      path: "/influencer-coupons/:id",
      name: "Influencer coupons",
      element: <PrivateRoute roles={["admin"]} component={InfluencerCoupons} />,
      route: PrivateRoute,
    },
    {
      path: "/payouts",
      name: "Influencer payouts",
      element: <PrivateRoute roles={["influencer"]} component={InfluencerPayouts} />,
      route: PrivateRoute,
    },
    {
      path: "/reports/coupons",
      name: "Influencer reports",
      element: <PrivateRoute roles={["influencer"]} component={InfluencerCouponReports} />,
      route: PrivateRoute,
    },
    {
      path: "/reports/commisions",
      name: "Influencer reports",
      element: <PrivateRoute roles={["influencer"]} component={InfluencerCommisionReports} />,
      route: PrivateRoute,
    },
    {
      path: "/users",
      name: "Users",
      element: <PrivateRoute roles={["admin"]} component={Users} />,
      route: PrivateRoute,
    },
    {
      path: "/orders",
      name: "Orders",
      element: <PrivateRoute roles={["admin"]} component={Orders} />,
      route: PrivateRoute,
    },
    {
      path: "/enquiries",
      name: "Enquiry",
      element: <PrivateRoute roles={["admin"]} component={Enquiry} />,
      route: PrivateRoute,
    },
    {
      path: "/subscriptions",
      name: "Subscriptions",
      element: <PrivateRoute roles={["admin"]} component={Subscription} />,
      route: PrivateRoute,
    },
    {
      path: "/category",
      name: "Category",
      element: <PrivateRoute roles={["admin"]} component={Category} />,
      route: PrivateRoute,
    },
    {
      path: "/course",
      name: "Course",
      element: <PrivateRoute roles={["admin"]} component={Course} />,
      route: PrivateRoute,
    },
    {
      path: "/subcourse",
      name: "Sub Course",
      element: <PrivateRoute roles={["admin"]} component={SubCourse} />,
      route: PrivateRoute,
    },
    {
      path: "/video",
      name: "Video",
      element: <PrivateRoute roles={["admin"]} component={Video} />,
      route: PrivateRoute,
    },
    {
      path: "/news",
      name: "News",
      element: <PrivateRoute roles={["admin"]} component={News} />,
      route: PrivateRoute,
    },
    {
      path: "/who-are-we",
      name: "Who are we",
      element: <PrivateRoute roles={["admin"]} component={WhoAreWe} />,
      route: PrivateRoute,
    },
    {
      path: "/terms_and_conditions",
      name: "terms_and_conditions",
      element: <PrivateRoute roles={["admin"]} component={TermsAndConditions} />,
      route: PrivateRoute,
    },
    {
      path: "/faq",
      name: "Faq",
      element: <PrivateRoute roles={["admin"]} component={Faq} />,
      route: PrivateRoute,
    },
    {
      path: "/testimonial",
      name: "Testimonial",
      element: <PrivateRoute roles={["admin"]} component={Testimonial} />,
      route: PrivateRoute,
    },
    {
      path: "/congratulations_box",
      name: "Congratulations",
      element: <PrivateRoute roles={["admin"]} component={CongratulationBox} />,
      route: PrivateRoute,
    },
    {
      path: "/footer",
      name: "Footer",
      element: <PrivateRoute roles={["admin"]} component={Footer} />,
      route: PrivateRoute,
    },
    {
      path: "/news_banner",
      name: "News Banner",
      element: <PrivateRoute roles={["admin"]} component={NewsBanner} />,
      route: PrivateRoute,
    },
    {
      path: "/main_banner",
      name: "Main Banner",
      element: <PrivateRoute roles={["admin"]} component={MainBanner} />,
      route: PrivateRoute,
    },
    {
      path: "/banner",
      name: "Banner",
      element: <PrivateRoute roles={["admin"]} component={Banner} />,
      route: PrivateRoute,
    },
  ],
};

// pages

// auth
const authRoutes: RoutesProps[] = [
  {
    path: "/auth/login2",
    name: "Login2",
    element: <Login />,
    route: Route,
  },
  // {
  //   path: "/auth/login3",
  //   name: "Login3",
  //   element: <LoginNew />,
  //   route: Route,
  // },
  {
    path: "/auth/logout2",
    name: "Logout2",
    element: <Logout2 />,
    route: Route,
  },
  {
    path: "/auth/register2",
    name: "Register2",
    element: <Register2 />,
    route: Route,
  },
  {
    path: "/auth/confirm2",
    name: "Confirm2",
    element: <Confirm2 />,
    route: Route,
  },
  {
    path: "/auth/forget-password2",
    name: "Forget Password2",
    element: <ForgetPassword2 />,
    route: Route,
  },
  {
    path: "/auth/signin-signup2",
    name: "SignIn-SignUp2",
    element: <SignInSignUp2 />,
    route: Route,
  },
  {
    path: "/auth/lock-screen2",
    name: "Lock Screen2",
    element: <LockScreen2 />,
    route: Route,
  },
];

// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[]) => {
  let flatRoutes: RoutesProps[] = [];

  routes = routes || [];
  routes.forEach((item: RoutesProps) => {
    flatRoutes.push(item);

    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

// All routes
const authProtectedRoutes = [dashboardRoutes, masterDataRoutes];
const publicRoutes = [...authRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
export { publicRoutes, authProtectedRoutes, authProtectedFlattenRoutes, publicProtectedFlattenRoutes };
